import { RowActions } from '@app/components/table/RowActions';
import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { ShowOnStreamAction } from '@app/modules/audit/components/ShowOnStreamAction';
import { PntStationStatusMatchDtoV2 } from '@mi-front/core';
import { Box } from '@mui/material';

interface ScheduleStatusMentionsDetailMatchActionsProps {
  match: PntStationStatusMatchDtoV2;
}

/**
 * Row actions for an unmatched mention detection (logger stream at match time).
 */
export function ScheduleStatusMentionsDetailMatchActions({
  match,
}: ScheduleStatusMentionsDetailMatchActionsProps) {
  const station = useActiveStation();

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <RowActions>
        <ShowOnStreamAction station={station.slug} datetime={match.datetime} tab="livementions" />
      </RowActions>
    </Box>
  );
}
